@if (dashboardStats$ | async; as stats) {
    <div class="row g-1">
        @for (stat of stats.basicStatistics; track stat.name) {
            <div class="col-6 col-lg-3">
                <sf-simple-stat-box
                    class="mb-3"
                    [heading]="stat.name"
                    [count]="stat.count"
                    [color]="stat.color"></sf-simple-stat-box>
            </div>
        }

        @for (chart of stats.chartStatistics; track chart.name) {
            <div class="col-12 col-lg-6">
                <sf-sparkline-area-chart [chartTitle]="chart.name" [chartData]="chart.data"></sf-sparkline-area-chart>
            </div>
        }
        @for (pie of stats.pieStatistics; track pie.name) {
            <div class="col-12 col-lg-6">
                <sf-sparkline-pie-chart [chartTitle]="pie.name" [chartData]="pie.data"></sf-sparkline-pie-chart>
            </div>
        }
    </div>
}
